<template>
  <v-container
    id="regular-tables"
    fluid
    tag="section"
  >
    <br>
    <h2 class="title-style">
      <v-icon class="icon-style">
        mdi-credit-card-check-outline
      </v-icon> Purchase List
    </h2>
    <v-card
      shaped
      color="#CFD8DC"
    >
      <br>
      <v-card-title>
        <v-row>
          <v-col
            cols="12"
            lg="4"
          >
            <v-text-field
              v-model="search"
              label="Search"
              append-icon="mdi-magnify"
              outlined
              dense
            />
          </v-col>
        </v-row>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="organizationPurchaseList"
        :search="search"
        class="elevation-1"
      >
        <template #item="{ item }">
          <tr>
            <td>{{ item.digi_board.external_id }}</td>
            <td>{{ item.digi_board.board_number }}</td>
            <td>
              {{ item.digi_board.location }}
            </td>
            <td>
              <v-chip
                color="#37474F"
                small
                outlined
                dark
              >
                {{ item.time_slots.length }}
              </v-chip>
            </td>
            <td>
              <v-btn
                class="mt-n2"
                elevation="1"
                fab
                x-small
                icon
                color="#37474F"
                @click.stop
                @click="getTimeSlotsDetails(item.time_slots)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <centre-spinner
        :loading="loading"
      />
      <organization-time-slots
        v-if="showTimeSlots"
        :digi-board-time-slots="digiBoardTimeSlots"
        @fetch-latest="getOrganizationPurchaseList()"
        @closed="showTimeSlots = false"
      />
    </v-card>
  </v-container>
</template>

<script>
  import spinner from 'src/views/dashboard/component/SpinnerCentre';
  import OrganizationTimeSlots from 'src/views/dashboard/organizations/OrganizationTimeSlots.vue';

  export default {
    name: 'OrganizationPurchaseList',
    components: {
      'centre-spinner': spinner,
      'organization-time-slots': OrganizationTimeSlots,
    },
    data () {
      return {
        search: '',
        loading: false,
        headers: [
          { text: 'Device Id', align: 'start', value: 'external_id' },
          { text: 'Board Number', value: 'board_number' },
          { text: 'Location', value: 'location' },
          { text: 'Purchased Slots', value: 'purchased_slots' },
          { text: 'View Slots', value: 'view_slots' },
        ],
        digiBoardTimeSlots: [],
        showTimeSlots: false,
      };
    },
    computed: {
      organizationPurchaseList () {
        return this.$store.getters['organizations/getOrganizationPurchaseList'];
      },
    },
    async mounted () {
      await this.getOrganizationPurchaseList();
    },
    methods: {
      async getOrganizationPurchaseList () {
        const organizationlId = this.$route.params.organizationId;
        this.loading = true;
        await this.$store.dispatch('organizations/fetchOrganizationPurchaseList', {
          organizationId: organizationlId,
        });
        this.loading = false;
      },
      getTimeSlotsDetails (timeSlots) {
        this.digiBoardTimeSlots = timeSlots;
        this.showTimeSlots = true;
      },
    },
  };
</script>
<style scoped>
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
</style>
